(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_06f77ac"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-bzhey-purchase="12"]';
  const initialize = root => {
    if (root.dataset.initialized === 'true') return;
    const status = root.querySelector('[data-status]');
    let config;
    try {
      config = JSON.parse(root.querySelector('[data-config]').textContent);
    } catch (error) {
      status.textContent = 'Purchase options could not load. Please refresh the page.';
      return;
    }
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-card]')];
    const submit = root.querySelector('[data-submit]');
    const frequency = root.querySelector('[data-plan]');
    const modes = ['onetime', 'subscription'];
    const indices = { onetime: 0, subscription: 0 };
    const planIds = {};
    let mode = config.defaultMode === 'subscription' ? 'subscription' : 'onetime';
    let busy = false;
    const normalize = value => String(value || '').toLowerCase()
      .replace(/\bone\b/g, '1').replace(/\btwo\b/g, '2')
      .replace(/\bthree\b/g, '3').replace(/\bfour\b/g, '4').replace(/\bfive\b/g, '5')
      .replace(/[^a-z0-9]/g, '');
    const variantNumber = value => {
      const text = String(value || '').trim();
      if (/^\d+$/.test(text)) return text;
      const match = text.match(/(?:ProductVariant\/|variants\/|[?&]variant=)(\d+)/i);
      return match ? match[1] : '';
    };
    const resolve = offer => {
      if (!offer) return null;
      const variants = offer.variants || [];
      if (String(offer.variantId || '').trim()) {
        const id = variantNumber(offer.variantId);
        return id ? variants.find(v => String(v.id) === id) || null : null;
      }
      const label = normalize(offer.label);
      const exact = variants.filter(v => normalize(v.title) === label);
      if (exact.length === 1) return exact[0];
      const optionMatch = variants.filter(v => String(v.title || '').split(' / ').some(part => normalize(part) === label));
      if (optionMatch.length === 1) return optionMatch[0];
      if (offer.mappedProduct && variants.length === 1) return variants[0];
      const count = Number(offer.packs);
      const matches = variants.filter(v => {
        const title = String(v.title || '').toLowerCase();
        return count > 0 && (title.trim() === String(count) ||
          new RegExp('(^|[^0-9])' + count + '\\s*[- ]?\\s*(packs?|bags?|tubes?|items?)(?=$|[^a-z])').test(title));
      });
      return matches.length === 1 ? matches[0] : null;
    };
    const offers = {};
    modes.forEach(m => {
      offers[m] = (config[m] || []).map(o => ({ ...o, variant: resolve(o) }));
    });
    const plans = offer => offer?.variant?.plans || [];
    const hasSubscriptions = config.enableSubscriptions && offers.subscription.some(o => plans(o).length > 0);
    const subscriptionVisible = Boolean(config.enableSubscriptions);
    const findDefault = m => {
      const list = offers[m];
      const requested = list.findIndex(o => o.slot === Number(config.defaultBundle));
      if (requested >= 0 && list[requested].variant?.available && (m !== 'subscription' || plans(list[requested]).length)) return requested;
      const available = list.findIndex(o => o.variant?.available && (m !== 'subscription' || plans(o).length));
      return available >= 0 ? available : Math.max(0, requested);
    };
    modes.forEach(m => { indices[m] = findDefault(m); });
    if (mode === 'subscription' && !hasSubscriptions) mode = 'onetime';
    if (!offers[mode].length && hasSubscriptions) mode = 'subscription';
    const current = m => offers[m][indices[m]];
    const getPlan = offer => {
      const list = plans(offer);
      return list.find(p => String(p.id) === String(planIds[offer?.slot])) || list[0] || null;
    };
    const money = (cents, currency) => new Intl.NumberFormat(config.locale || 'en', {
      style: 'currency', currency: currency || config.currency || config.baseCurrency || 'EUR'
    }).format(Number(cents) / 100);
    const pricing = (offer, m) => {
      if (!offer) return null;
      const allocation = m === 'subscription' ? getPlan(offer) : null;
      const source = allocation || offer.variant;
      if (source && Number.isFinite(Number(source.price))) {
        const compare = Number(offer.variant?.compare || 0) ||
          (config.currency === config.baseCurrency ? Number(offer.offerCompare || 0) : 0);
        return { total: Number(source.price), compare, currency: config.currency, reference: m === 'subscription' && !allocation };
      }
      return { total: Number(offer.offerPrice || 0), compare: Number(offer.offerCompare || 0), currency: config.baseCurrency, reference: true };
    };
    const checkoutMatches = (offer, m) => {
      if (!offer?.variant?.available) return false;
      const source = m === 'subscription' ? getPlan(offer) : offer.variant;
      return Boolean(source && Number.isFinite(Number(source.price)) && Number(source.price) > 0);
    };
    const issueFor = (offer, m) => {
      if (!offer) return config.noOffersLabel;
      if (!offer.variant) return config.missingVariantLabel;
      if (!offer.variant.available) return config.soldOutLabel;
      if (m === 'subscription' && !getPlan(offer)) return config.missingPlanLabel;
      return '';
    };
    const make = (tag, cls, value) => {
      const element = document.createElement(tag);
      if (cls) element.className = cls;
      if (value != null) element.textContent = value;
      return element;
    };
    const counts = o => o ? `${o.packs} ${Number(o.packs) === 1 ? config.packLabel : config.packsLabel}` : '';
    const renderPrice = (node, offer, m) => {
      node.replaceChildren();
      const price = pricing(offer, m);
      if (!price) {
        node.append(make('span', 'bzpo-price-empty', config.unavailableLabel));
        return;
      }
      if (config.showCompare && price.compare > price.total) node.append(make('s', 'bzpo-compare', money(price.compare, price.currency)));
      node.append(make('span', 'bzpo-amount', money(price.total, price.currency)));
      if (config.showPerPack && Number(offer.packs) > 0) node.append(make('small', 'bzpo-unit', `${money(price.total / Number(offer.packs), price.currency)} / ${config.packLabel}`));
      if (price.reference) node.append(make('small', 'bzpo-unit bzpo-reference', config.subscriptionReferenceLabel));
    };
    const render = () => {
      cards.forEach(card => {
        const m = card.dataset.card;
        const list = offers[m];
        const offer = current(m);
        card.hidden = m === 'subscription' && !subscriptionVisible;
        const active = m === mode;
        card.classList.toggle('active', active);
        const header = card.querySelector('[data-mode-button]');
        header.setAttribute('aria-expanded', String(active));
        header.setAttribute('aria-pressed', String(active));
        card.querySelector('[data-expanded]').hidden = !active;
        card.querySelector('[data-summary]').textContent = counts(offer);
        renderPrice(card.querySelector('[data-total]'), offer, m);
        const buttons = card.querySelector('[data-offers]');
        buttons.replaceChildren();
        list.forEach((o, index) => {
          const button = make('button', 'bzpo-offer');
          button.type = 'button';
          button.dataset.offerIndex = String(index);
          button.dataset.offerMode = m;
          button.setAttribute('aria-pressed', String(index === indices[m]));
          button.append(make('span', 'bzpo-offer-title', o.label));
          button.append(make('span', 'bzpo-offer-count', counts(o)));
          const offerTag = config.showOfferTags ? o.slot === 1 ? config.mostBoughtLabel : config.bestValueLabel : '';
          if (offerTag) button.append(make('span', 'bzpo-offer-tag', offerTag));
          else if (o.badgeShow && o.badge) button.append(make('span', 'bzpo-badge', o.badge));
          buttons.append(button);
        });
        const info = card.querySelector('[data-info]');
        info.replaceChildren();
        if (offer) {
          if (offer.description && normalize(offer.description) !== normalize(offer.label)) info.append(make('span', 'bzpo-detail-text', offer.description));
          const price = pricing(offer, m);
          const benefits = make('div', 'bzpo-benefits');
          if (config.showSavings && price && price.compare > price.total) {
            const percent = Math.round((price.compare - price.total) / price.compare * 100);
            benefits.append(make('span', 'bzpo-saving', `${config.saveLabel} ${percent}% (${money(price.compare - price.total, price.currency)})`));
          }
          if (config.freeShippingLabel) {
            const shipping = make('span', 'bzpo-shipping');
            shipping.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7M3 10H1"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
            shipping.append(make('span', '', config.freeShippingLabel));
            benefits.append(shipping);
          }
          if (benefits.childElementCount) info.append(benefits);

        } else info.append(make('span', '', config.noOffersLabel));
        const giftPanel = card.querySelector('[data-gift-panel]');
        if (giftPanel) {
          const subscribed = m === 'subscription';
          const includedCount = Math.max(0, Math.floor(Number(offer?.giftCount) || 0));
          const visibleCount = subscribed ? Math.min(3, includedCount) : config.enableSubscriptions ? 3 : Math.min(3, includedCount);
          giftPanel.hidden = !offer || visibleCount === 0;
          giftPanel.classList.toggle('is-locked', !subscribed && includedCount === 0);
          giftPanel.querySelector('[data-gift-heading]').textContent = subscribed ? config.giftIncludedLabel.replace('{count}', String(includedCount)) : includedCount > 0 ? config.oneTimeGiftHeading.replace('{count}', String(includedCount)) : config.giftTeaserLabel;
          giftPanel.querySelector('[data-gift-list]').style.setProperty('--gift-columns', String(visibleCount || 1));
          giftPanel.querySelectorAll('[data-gift-tile]').forEach((tile, index) => {
            tile.hidden = index >= visibleCount;
            const locked = index >= includedCount;
            tile.classList.toggle('is-locked', locked);
            const state = tile.querySelector('[data-gift-state]');
            if (state) state.textContent = locked ? config.giftLockedState : config.giftIncludedState;
          });
          const caption = giftPanel.querySelector('[data-gift-caption]');
          caption.textContent = subscribed ? config.giftUnlockedCaption : includedCount > 0 && config.enableSubscriptions ? config.oneTimeGiftCaption : '';
          caption.hidden = !caption.textContent;
        }
        if (m === 'subscription' && frequency) {
          const allocation = getPlan(offer);
          frequency.replaceChildren();
          plans(offer).forEach(p => {
            let label = p.name;
            if (config.compactFrequencyLabels) {
              label = String(label || '').replace(/^deliver(?:y)?\s+/i, '').replace(/\s*[,|–—-]\s*\d+(?:[.,]\d+)?\s*%\s*off\s*$/i, '').trim();
              label = label.charAt(0).toUpperCase() + label.slice(1);
            }
            const option = make('option', '', label || p.name);
            option.value = String(p.id);
            frequency.append(option);
          });
          if (allocation) frequency.value = String(allocation.id);
          frequency.disabled = !allocation;
          frequency.closest('[data-frequency]').hidden = !allocation;
          const note = card.querySelector('[data-preview-note]');
          note.hidden = Boolean(allocation);
          note.textContent = issueFor(offer, m) || config.subscriptionSetupLabel;
        }
      });
      const offer = current(mode);
      const valid = checkoutMatches(offer, mode);
      submit.disabled = busy || !valid;
      submit.setAttribute('aria-busy', String(busy));
      submit.textContent = busy ? config.loadingLabel : valid ? config.buttonLabel : offer?.variant && !offer.variant.available ? config.soldOutLabel : mode === 'subscription' && offer?.variant && !getPlan(offer) ? config.subscriptionPendingButton : config.setupPriceLabel;
      root.dataset.selectedMode = mode;
    };
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-mode-button], [data-offer-index]');
      if (!button || !root.contains(button) || busy) return;
      event.stopPropagation();
      const lastFocus = document.activeElement;
      if (button.dataset.modeButton) {
        const nextMode = button.dataset.modeButton;
        if (nextMode === 'subscription' && !subscriptionVisible) return;
        const previousSlot = current(mode)?.slot;
        const same = offers[nextMode].findIndex(o => o.slot === previousSlot);
        if (same >= 0) indices[nextMode] = same;
        mode = nextMode;
      } else {
        mode = button.dataset.offerMode;
        indices[mode] = Number(button.dataset.offerIndex);
      }
      status.textContent = '';
      render();
      if (lastFocus === button && button.dataset.offerIndex) root.querySelector(`[data-offer-mode="${mode}"][data-offer-index="${indices[mode]}"]`)?.focus({ preventScroll: true });
    });
    frequency?.addEventListener('change', () => {
      const offer = current('subscription');
      if (offer) planIds[offer.slot] = frequency.value;
      status.textContent = '';
      render();
    });
    const bundleCounts = item => {
      const known = {};
      const packs = Number(item.properties?._bzhey_packs_per_bundle || known[String(item.variant_id || item.id)] || 0);
      if (!packs) return null;
      const pouches = Number(item.properties?._bzhey_pouches_per_bundle || 0);
      const quantity = Number(item.quantity || 1);
      return { packs: packs * quantity, pouches: pouches * quantity, quantity };
    };
    const deliveryText = item => {
      const value = bundleCounts(item);
      if (!value) return '';
      return `${config.cartReceiveLabel}: ${value.packs} ${value.packs === 1 ? config.packLabel : config.packsLabel} (${value.quantity} ${value.quantity === 1 ? config.bundleLabel : config.bundlesLabel})`;
    };
    const annotateNativeCart = cart => {
      (cart.items || []).forEach(item => {
        const text = deliveryText(item);
        if (!text || !item.key) return;
        document.querySelectorAll('cart-drawer, cart-drawer-component, #cart-drawer').forEach(drawer => {
          drawer.querySelectorAll('[data-key]').forEach(row => {
            if (row.dataset.key !== item.key) return;
            const details = row.querySelector('.cart-items__details, .cart-item__details, [data-cart-item-details]');
            if (!details) return;
            let note = details.querySelector('.bzpo-native-bundle-note');
            if (!note) { note = make('p', 'bzpo-native-bundle-note'); details.append(note); }
            note.textContent = text;
          });
        });
      });
    };
    const openFallbackCart = cart => {
      let dialog = root.querySelector('[data-bzpo-cart-dialog]');
      if (!dialog) {
        dialog = make('dialog', 'bzpo-cart-dialog');
        dialog.dataset.bzpoCartDialog = '';
        dialog.setAttribute('aria-label', config.cartTitle);
        root.append(dialog);
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => submit.focus({ preventScroll: true }));
      }
      dialog.replaceChildren();
      const panel = make('div', 'bzpo-cart-panel');
      const header = make('div', 'bzpo-cart-header');
      header.append(make('h2', '', config.cartTitle));
      const close = make('button', 'bzpo-cart-close', '×'); close.type = 'button';
      close.setAttribute('aria-label', config.cartCloseLabel); close.addEventListener('click', () => dialog.close());
      header.append(close); panel.append(header);
      const items = make('div', 'bzpo-cart-lines');
      (cart.items || []).forEach(item => {
        const row = make('article', 'bzpo-cart-line');
        const imageUrl = item.featured_image?.url || item.image;
        if (imageUrl) {
          const image = make('img'); image.src = imageUrl; image.alt = item.product_title || item.title || '';
          image.width = 74; image.height = 90; row.append(image);
        }
        const detail = make('div', 'bzpo-cart-line-details');
        detail.append(make('strong', '', item.product_title || item.title));
        if (item.variant_title && item.variant_title !== 'Default Title') detail.append(make('span', '', item.variant_title));
        const delivered = deliveryText(item);
        if (delivered) detail.append(make('strong', 'bzpo-cart-contents', delivered));
        else detail.append(make('span', '', `${config.cartQuantityLabel}: ${item.quantity}`));
        const planName = item.selling_plan_allocation?.selling_plan?.name;
        if (planName) detail.append(make('span', '', planName));
        detail.append(make('span', '', money(item.final_line_price ?? item.line_price ?? 0)));
        row.append(detail); items.append(row);
      });
      panel.append(items);
      const footer = make('div', 'bzpo-cart-footer');
      footer.append(make('strong', 'bzpo-cart-total', `${config.cartSubtotalLabel}: ${money(cart.total_price || 0)}`));
      const checkout = make('a', 'bzpo-cart-checkout', config.cartCheckoutLabel);
      checkout.href = config.cartUrl.replace(/\/cart\/?$/, '') + '/checkout';
      const view = make('a', 'bzpo-cart-view', config.cartViewLabel); view.href = config.cartUrl;
      footer.append(checkout, view); panel.append(footer); dialog.append(panel);
      if (!dialog.open) dialog.showModal();
    };
    submit.addEventListener('click', async event => {
      event.preventDefault();
      event.stopPropagation();
      if (busy || submit.disabled) return;
      const offer = current(mode);
      const plan = mode === 'subscription' ? getPlan(offer) : null;
      if (!checkoutMatches(offer, mode)) return;
      const item = {
        id: offer.variant.id, quantity: 1,
        properties: {
          [config.cartContentsLabel || 'Bundle contents']: counts(offer),
          _bzhey_packs_per_bundle: String(offer.packs),
          _bzhey_pouches_per_bundle: String(offer.pouches),
          _bzhey_offer: offer.label,
          _bzhey_purchase_mode: mode,
          _bzhey_free_gift_count: String(offer.giftCount || 0)
        }
      };
      if (plan) item.selling_plan = plan.id;
      const dawnDrawer = document.querySelector('cart-drawer');
      const dawn = dawnDrawer && typeof dawnDrawer.getSectionsToRender === 'function' && typeof dawnDrawer.renderContents === 'function';
      const sectionIds = new Set();
      if (dawn) dawnDrawer.getSectionsToRender().forEach(section => sectionIds.add(section.id));
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(element => sectionIds.add(element.dataset.sectionId));
      if (document.getElementById('shopify-section-cart-drawer-section')) sectionIds.add('cart-drawer-section');
      const body = { items: [item] };
      if (sectionIds.size) { body.sections = [...sectionIds].slice(0, 5); body.sections_url = window.location.pathname; }
      if (dawn && typeof dawnDrawer.setActiveElement === 'function') dawnDrawer.setActiveElement(submit);
      busy = true;
      status.textContent = '';
      render();
      let added = false;
      try {
        const response = await fetch(config.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || config.errorLabel);
        added = true;
        const cartResponse = await fetch(config.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(config.cartRefreshErrorLabel);
        const cart = await cartResponse.json();
        let opened = false;
        if (dawn && result.sections) {
          try {
            await dawnDrawer.renderContents(result);
            if (typeof dawnDrawer.open === 'function') dawnDrawer.open();
            opened = true;
          } catch (error) { opened = false; }
        }
        if (!opened) {
          const horizon = document.querySelector('cart-drawer-component, theme-drawer#cart-drawer');
          if (horizon) {
            const update = new CustomEvent('cart:update', { bubbles: true, detail: {
              resource: cart, sourceId: 'bzhey-purchase-options',
              data: { source: 'bzhey-purchase-options', itemCount: cart.item_count, sections: result.sections || {} }
            } });
            document.dispatchEvent(update);
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
            const freshDrawer = document.querySelector('cart-drawer-component');
            const wrapper = freshDrawer?.closest('theme-drawer') || document.querySelector('theme-drawer#cart-drawer');
            const target = wrapper || freshDrawer;
            if (typeof target?.open === 'function') { target.open(); opened = true; }
            else if (typeof target?.showDialog === 'function') { target.showDialog(); opened = true; }
          }
        }
        if (!opened) openFallbackCart(cart);
        annotateNativeCart(cart);
        status.textContent = config.successLabel;
      } catch (error) {
        status.textContent = added ? config.cartRefreshErrorLabel : error.message || config.errorLabel;
      } finally {
        busy = false;
        render();
      }
    });
    render();
  };
  const scan = scope => {
    if (scope.matches?.(selector)) initialize(scope);
    scope.querySelectorAll?.(selector).forEach(initialize);
  };
  scan(document);
  document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:block:select', event => scan(event.target));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_403d34f"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bzhey-customer-marquee')) {
    customElements.define('bzhey-customer-marquee', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('.bzm__dialog');
        this.player = this.querySelector('.bzm__player');
        this.toggle = this.querySelector('.bzm__toggle');
        const lower = this.querySelector('[data-row="bottom"] [data-base]');
        if (lower && !lower.dataset.rotated) {
          const shift = Math.ceil(lower.children.length / 2);
          for (let i = 0; i < shift; i++) lower.append(lower.firstElementChild);
          lower.dataset.rotated = 'true';
        }
        this.toggle?.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          this.toggle.setAttribute('aria-pressed', String(paused));
          this.toggle.querySelector('span').textContent = paused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        }, options);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.bzm__video');
          if (!button || !this.contains(button)) return;
          const template = button.closest('.bzm__card').querySelector('template');
          if (!template) return;
          this.trigger = button;
          this.player.replaceChildren(template.content.cloneNode(true));
          this.setAttribute('data-modal', '');
          this.dialog.showModal();
          this.player.querySelector('video')?.play().catch(() => {});
        }, options);
        this.querySelector('.bzm__close')?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.player.querySelector('video')?.pause();
          this.player.replaceChildren();
          this.removeAttribute('data-modal');
          this.trigger?.focus({ preventScroll: true });
        }, options);
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => this.rebuild(), options);
        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.rebuild());
        });
        this.observer.observe(this);
        this.rebuild();
      }
      duplicate(node) {
        const clone = node.cloneNode(true);
        clone.removeAttribute('data-original');
        clone.removeAttribute('data-base');
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[data-original]').forEach(item => item.removeAttribute('data-original'));
        clone.querySelectorAll('a,button,[tabindex]').forEach(item => item.setAttribute('tabindex', '-1'));
        return clone;
      }
      rebuild() {
        const key = `${this.getBoundingClientRect().width}:${innerWidth < 750}:${this.motion.matches}`;
        if (key === this.layoutKey) return;
        this.layoutKey = key;
        this.removeAttribute('data-ready');
        this.querySelectorAll('.bzm__row').forEach(row => {
          const track = row.querySelector('.bzm__track');
          const base = track.querySelector('[data-base]');
          track.querySelectorAll(':scope > [data-clone]').forEach(node => node.remove());
          base.querySelectorAll(':scope > [data-clone]').forEach(node => node.remove());
          const originals = [...base.children];
          if (!originals.length || !row.clientWidth || this.motion.matches) return;
          const minimum = row.clientWidth + originals[0].getBoundingClientRect().width;
          let loops = 0;
          while (base.getBoundingClientRect().width < minimum && loops++ < 50) {
            originals.forEach(node => base.append(this.duplicate(node)));
          }
          const distance = base.getBoundingClientRect().width;
          track.style.setProperty('--bzm-distance', `${distance}px`);
          track.style.setProperty('--bzm-duration', `${distance / Math.max(5, Number(this.dataset.speed) || 20)}s`);
          track.append(this.duplicate(base));
        });
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
        this.player?.querySelector('video')?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.layoutKey = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_7951dce"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'bzhey-local-midnight-cutoff';
  if (customElements.get(tag)) return;
  class LocalMidnightCutoff extends HTMLElement {
    static get observedAttributes() { return ['data-days', 'data-today', 'data-tomorrow', 'data-other', 'data-prefix', 'data-unavailable']; }
    connectedCallback() {
      if (this.timer != null) return;
      this.countdown = this.querySelector('[data-countdown]');
      this.dispatch = this.querySelector('[data-dispatch]');
      this.update = () => this.render(new Date());
      this.onVisibility = () => { if (!document.hidden) this.update(); };
      this.update();
      this.timer = window.setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('focus', this.update);
    }
    disconnectedCallback() {
      if (this.timer != null) window.clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.removeEventListener('focus', this.update);
    }
    attributeChangedCallback() {
      if (this.isConnected && this.update) this.update();
    }
    render(now) {
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      const remaining = Math.max(0, Math.ceil((midnight.getTime() - now.getTime()) / 1000));
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      if (this.countdown) this.countdown.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
      if (!this.dispatch) return;
      const days = new Set((this.dataset.days || '').split(',').filter(value => value.trim() !== '').map(Number).filter(day => Number.isInteger(day) && day >= 0 && day <= 6));
      let target = null;
      let offset = 0;
      for (; offset < 7; offset++) {
        const candidate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + offset, 12);
        if (days.has(candidate.getDay())) { target = candidate; break; }
      }
      if (!target) {
        this.dispatch.textContent = this.dataset.unavailable || 'To be confirmed';
        return;
      }
      const weekday = new Intl.DateTimeFormat('en', { weekday: 'long' }).format(target);
      let label;
      if (offset === 0) label = this.dataset.today || 'Today';
      else if (offset === 1) label = this.dataset.tomorrow || 'Tomorrow';
      else label = this.dataset.other || '{day}';
      label = label.replace(/\{\{\s*day\s*\}\}|\{day\}|\[day\]/gi, weekday);
      const prefix = (this.dataset.prefix || '').trim();
      if (prefix) {
        const escaped = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        label = label.replace(new RegExp('^' + escaped + '(?:\\s+|$)', 'i'), '').trim();
      }
      const value = label || (offset === 0 ? 'Today' : offset === 1 ? 'Tomorrow' : weekday);
      this.dispatch.textContent = value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
  customElements.define(tag, LocalMidnightCutoff);
})();
  } catch(e) { console.error(e); }
})();

})();
